import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import React, { useState } from 'react'
//import About from './components/About';
import Alert from './components/Alert';

// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
// } from "react-router-dom";

//import About from './components/About';
function App() {
  const [mode, setMode] = useState('light')
  const [alert, setAlert] = useState(null);
  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    })
    setTimeout(() => {
      setAlert(null);
    }, 2500);
  }
  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#074956';
      showAlert('Dark mode has been Enabled', 'Success');
      document.title = ('TextUtil - DarkMode');
    }
    else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      showAlert('Light mode has been Enabled', 'Success');
      document.title = ('TextUtil - LightMode');

    }

  }
  return (
    <>
      
        <Navbar title="TextUtils" aboutText="About TextUtils" mode={mode} toggleMode={toggleMode} />
        <Alert alert={alert} />
        <div className='container'>
        <TextForm heading="Enter text to analyze" mode={mode} showAlert={showAlert} />
        </div>
          




    </>
  );
}


export default App;
 //Navbar.propTypes = {title: PropTypes.string.isrequired, aboutText: PropTypes.string};
// Navbar.defaultProps = { 
//   title : 'Set title here',
//   aboutText: 'About text here',
//   };


